<template>
    <v-app id="inspire">
        <v-content>
            <v-container
                    class="fill-height"
                    fluid
            >
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col
                            cols="12"
                            sm="12"
                            md="4"
                    >
                        <v-card width="auto " :fullscreen="$vuetify.breakpoint.xsOnly" class="elevation-12">
                            <v-toolbar
                                    color="secondary"
                                    dark
                                    flat
                            >
                                <v-toolbar-title>{{$t('sign_in_title_form')}}</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-form v-model="formValid" @submit.prevent="submit">
                                    <v-text-field
                                            class="ltr"
                                            :label="$t('mobile')"
                                            v-model="mobile"
                                            name="mobile"
                                            prepend-icon="mdi-account-tie"
                                            type="text"
                                            :rules="[rules.required,rules.mobile]"
                                    />

                                    <v-text-field
                                            class="ltr"
                                            id="password"
                                            :label="$t('password')"
                                            v-model="password"
                                            name="password"
                                            prepend-icon="mdi-lock"
                                            type="password"
                                            :rules="[rules.required,rules.password]"
                                    />
                                    <v-checkbox
                                            v-if="false"
                                            v-model="rememberToken"
                                            value="1"
                                            :label="$t('remember_token')"
                                            type="checkbox"
                                    ></v-checkbox>
                                </v-form>
                            </v-card-text>
                            <v-card-actions>
                                <v-btn
                                        color="success"
                                       :loading="loading"
                                        type="submit"
                                       :disabled="loading || !formValid"
                                       @click="submit"
                                >{{$t('sign_in')}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import { mapMutations } from 'vuex';
    import AuthService from '../services/AuthService';
    import UserService from '../services/UserService';
    import {mobile, required, password} from '../scripts/validationRules';

    export default {
        name: 'SignIn',
        data() {
            return {
                loading: false,
                formValid: false,

                mobile: null,
                password: null,
                rememberToken : false,

                showPass: false,
                resetPass: false,
                rules: {
                    required: required,
                    mobile: mobile,
                    password: password
                }
            }
        },
        methods: {
            ...mapMutations('auth', [
                'SET_TOKEN'
            ]),
            async submit() {
                this.loading = true;
                try {

                    let { data } = await AuthService.createSession(this.mobile, this.password);
                    this.SET_TOKEN(data.value.jwt_token);
                    UserService.storePermission(data.value.user_permissions);

                    this.$notify({
                        group: 'formValidation',
                        type: 'success',
                        title: this.$t('success_submit'),
                        text: data.message
                    });

                    this.$router.push({
                        name: 'Dashboard'
                    });
                } finally {
                    this.loading = false;
                }
            }
        }
    }
</script>